import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, LOGEVENT, MODULE } from '../../framework/constant/constant';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api";
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { toast } from 'react-toastify';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';

const ChannelGroupsEditForm = () => {

    const lang = useTranslation();
    const navigate = useNavigate();
    const { SID } = useParams();
    const loc = useLocation();

    const blankDataItem = {
        Description: "",
        Archive: false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [linkedChannel, setLinkedChannel] = useState(false);
    const [gridDataLinkedChannels, setGridDataLinkedChannels] = useState([]);

    useEffect(() => {
        if (SID > 0) {
            loadEditData();
        }
    }, []);
    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };
    const loadEditData = async () => {
        let res = await API.getEntity(ENTITYNAME.ChannelGroups, parseInt(SID));

        if (res.success && res.data) {
            const groupData = res.data;
            setDataItem({
                ...groupData,
                Description: loc.state?.copy ? "Copy of " + groupData.Description : groupData.Description
            });

            let channelRes = await API.getData(ENTITYNAME.Channel);

            if (channelRes.success) {
                const mappedLinkedChannels = (groupData.LinkedChannels || []).map(lc => {
                    const channel = channelRes.data.find(c => c._id === lc._id);
                    return {
                        _id: lc._id,
                        SID: lc.SID,
                        FullChannelName: channel?.FullChannelName ?? "",
                        EPGCode: channel?.EPGCode ?? "",
                        AsRunCode: channel?.AsRunCode ?? "",
                        AutomationChannelName: channel?.AutomationChannelName ?? "",
                        Automation: channel?.Automation?.Name ?? "",
                        Timezone: channel?.Timezone ?? ""
                    };
                });
                setGridDataLinkedChannels(mappedLinkedChannels);
            }
        }
    };

    const isValid = () => {
        if (dataItem.Description == "" || dataItem.Description == undefined) {
            toast.error(`${lang.please_enter_description_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        return true;
    }
    const handleSubmit = async () => {
        if (!isValid()) return;

        let finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Description: dataItem?.Description,
            LinkedChannels: gridDataLinkedChannels.length > 0 ? gridDataLinkedChannels.map((x) => {
                return {
                    _id: x._id,
                    SID: x.SID,
                    FullChannelName: x.FullChannelName
                }
            }) : [],
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]],
        }
        if (loc.state.copy) {
            delete finalData._id;
            delete finalData.SID;
        }

        console.log(finalData)

        let res = await API.saveData(ENTITYNAME.ChannelGroups, finalData);
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CHANNEL_GROUPS, data: res.data, message: res.message };
        API.SaveLogs(logData);
        if (!res.success) {
            toast.error(res.message, { position: toast.POSITION.TOP_RIGHT, });
        } else {
            navigate(-1);
        }
    }
    const deleteLinkedChannel = (dataItem) => {
        setGridDataLinkedChannels(gridDataLinkedChannels.filter((obj) => dataItem._id != obj._id));
        toast.success(`${lang.delete_successfully_grid_data_success_toast_message}`, {
            position: toast.POSITION.TOP_RIGHT
        });
    }
    const MyCommandCellLinkedChannel = (props) => (
        <td style={{ padding: "3px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteLinkedChannel(props.dataItem), () => { })} />
        </td>
    )
    const handleGridLinkedChannel = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, gridDataLinkedChannels, "FullChannelName")
        setGridDataLinkedChannels([...gridDataLinkedChannels, ...newData]);
    }

    return (
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader
                    title={dataItem?.Description != "" ? dataItem?.Description : lang.channel_groups_header}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate(-1)}
                />
                <div className="row">
                    <div className="col-6">
                        <label htmlFor="">{lang.description_label}*</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="Description"
                            value={dataItem.Description}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-4">
                        <input
                            name="Archive"
                            type="checkbox"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label className="ml-1">{lang.archive}</label>
                    </div>
                </div>
                <div>
                    <AddRoundButton onClick={() => setLinkedChannel(true)} style={{ marginTop: "20px", marginLeft: "5px" }} />
                    <span className='float-right mr-3' style={{ marginTop: "36px" }}>{lang.linked_channels_label}</span>
                    <Grid
                        style={{ height: "65vh", margin: '0px 10px 40px 10px', overflow: "hidden" }}
                        className="mt-2"
                        data={gridDataLinkedChannels}
                    >
                        <GridColumn cell={MyCommandCellLinkedChannel} width="40px" locked />
                        <GridColumn field="FullChannelName" title={lang.channel_column} />
                        <GridColumn field="EPGCode" title="EPG Code" />
                        <GridColumn field="AsRunCode" title="As Run Code" />
                        <GridColumn field="AutomationChannelName" title="Automation Channel Name" />
                        <GridColumn field="Automation" title="Automation" />
                        <GridColumn field="Timezone" title="Timezone" />
                    </Grid>
                </div>
            </div>
            {linkedChannel && <CollectionSelection setDataList={handleGridLinkedChannel} closeForm={() => setLinkedChannel(false)} entityname={ENTITYNAME.Channel} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        </div >
    )
}

export default ChannelGroupsEditForm